/**
 	 * 腾讯音视频相关sdk信息配置
 	 * @param flag 
 	 * @returns 
 	 */
import imInfo from '@/constant/imConfig'
 export const APPCONFG = (flag) => {
  let config = {
    APPID: 1400694143,
    APPSECRET: imInfo["test"]
  }
  switch(flag) {
    case 'pre':
      config = { ...config, ...{
        APPID: 1400694207,
        APPSECRET: imInfo["pre"]
      }}
      break;
    case 'production':
      config = { ...config, ...{
        // APPID: 1400596395,
        // APPSECRET: '9b225b108e41a8ec2d0ac2ce6cbf1c07b19c1633072645abd035a1acac6b515f'
        APPID: process.env.VUE_APP_ENV === 'zh'? 1400805028 : 1400677520,
        APPSECRET: process.env.VUE_APP_ENV === 'zh'? imInfo.zh["production"] : imInfo["production"]
      }}
      break; 
  }
  return config
}